import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createObjectifAutoEvaluationRequest, fetchObjectifsNMoins1StepRequest } from "../../../../redux/actions/performanceActions";
import { asArray, Field, StepState } from "../performanceUi";

export default function ObjectifsNMoins1Step({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.objectifsNMoins1);
    const data = slice.dataByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const objectifs = asArray(data?.objectifs);
    const revisions = asArray(data?.revisions);
    const [drafts, setDrafts] = useState({});

    useEffect(() => {
        dispatch(fetchObjectifsNMoins1StepRequest(progressId));
    }, [dispatch, progressId]);

    const updateDraft = (objectifId, patch) => setDrafts((current) => ({
        ...current,
        [objectifId]: { ...(current[objectifId] || {}), ...patch },
    }));

    const submitAutoEval = (objectif) => {
        const draft = drafts[objectif.id] || {};
        dispatch(createObjectifAutoEvaluationRequest(objectif.id, {
            evaluationProgressId: Number(progressId),
            tauxRealisation: draft.tauxRealisation,
            commentaire: draft.commentaire,
        }));
    };

    const latestRevision = (objectifId, typeAction) => revisions.find((revision) => revision.objectifId === objectifId && revision.typeAction === typeAction);
    const isExpired = (dateFin) => {
        if (!dateFin) return false;
        const deadline = new Date(dateFin);
        deadline.setHours(23, 59, 59, 999);
        return new Date() > deadline;
    };

    return (
        <StepState loading={loading} error={error} empty={!data}>
            {data?.campagneNMoins1Nom && (
                <div className="perf-state perf-state--inline">
                    Objectifs N validés de : {data.campagneNMoins1Nom}
                </div>
            )}
            {data?.blockedReason && <div className="perf-state perf-state--warning">{data.blockedReason}</div>}
            {!data?.blockedReason && objectifs.length === 0 && <div className="perf-state">Aucun objectif N-1 disponible.</div>}
            <div className="perf-stack">
                {objectifs.map((objectif) => {
                    const autoEvaluation = latestRevision(objectif.id, "AUTO_EVALUATION");
                    const managerEvaluation = latestRevision(objectif.id, "MANAGER_EVALUATION");
                    const draft = drafts[objectif.id] || {};
                    const expired = isExpired(objectif.dateFin);
                    const locked = Boolean(managerEvaluation);
                    return (
                        <article className="perf-item" key={objectif.id}>
                            <div className="perf-item__head">
                                <h3>{objectif.titre}</h3>
                                <span className="perf-badge perf-badge--blue">{objectif.approvalStatus || objectif.statusObjectif || "OBJECTIF"}</span>
                            </div>
                            <p>{objectif.description || "Aucune description."}</p>
                            <dl className="perf-facts">
                                <div><dt>Indicateur</dt><dd>{objectif.indicateur || "-"}</dd></div>
                                <div><dt>Cible</dt><dd>{objectif.performanceCible ?? "-"}</dd></div>
                                <div><dt>Poids</dt><dd>{objectif.poids ?? "-"}%</dd></div>
                                <div><dt>Auto-evaluation</dt><dd>{autoEvaluation?.tauxRealisation ?? "-"}%</dd></div>
                                <div><dt>Validation manager</dt><dd>{managerEvaluation?.tauxRealisation ?? "-"}%</dd></div>
                            </dl>
                            {locked && <div className="perf-state perf-state--inline">Valide par le manager</div>}
                            {!expired && !locked && <div className="perf-state perf-state--warning">Auto-evaluation disponible apres la date d'echeance.</div>}
                            <div className="perf-form-row">
                                <Field label="Taux realise">
                                    <input
                                        type="number"
                                        min="0"
                                        max="200"
                                        disabled={!expired || locked}
                                        value={draft.tauxRealisation ?? autoEvaluation?.tauxRealisation ?? ""}
                                        onChange={(event) => updateDraft(objectif.id, { tauxRealisation: event.target.value })}
                                    />
                                </Field>
                                <Field label="Commentaire">
                                    <input
                                        disabled={!expired || locked}
                                        value={draft.commentaire ?? autoEvaluation?.commentaire ?? ""}
                                        onChange={(event) => updateDraft(objectif.id, { commentaire: event.target.value })}
                                    />
                                </Field>
                            </div>
                            <div className="perf-actions">
                                <button className="perf-btn perf-btn--primary" type="button" disabled={!expired || locked} onClick={() => submitAutoEval(objectif)}>
                                    Auto-evaluer N-1
                                </button>
                            </div>
                        </article>
                    );
                })}
            </div>
        </StepState>
    );
}
